import type React from 'react'
import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { DropdownHeaderPadding } from './DropdownHeader.h'

import {
  DropdownHeaderAlignItems,
  DropdownHeaderDirection,
  DropdownHeaderJustifyContent,
  DropdownHeaderPaddings,
} from './DropdownHeader.h'
import { DropdownHeaderStyled } from './DropdownHeader.styled'

export interface IDropdownHeaderProps {
  children: React.ReactNode
  isOpened?: boolean
  width?: number
  height?: number
  direction?: DropdownHeaderDirection
  justifyContent?: DropdownHeaderJustifyContent
  alignItems?: DropdownHeaderAlignItems
  paddings?: DropdownHeaderPadding
  onClick?: () => void
  color?: TextBoxColors
}

export const DropdownHeader = ({
  children,
  isOpened,
  width = 0,
  height = 0,
  direction = DropdownHeaderDirection.Row,
  justifyContent = DropdownHeaderJustifyContent.FlexStart,
  alignItems = DropdownHeaderAlignItems.FlexStart,
  paddings = DropdownHeaderPaddings.SIZE_0,
  onClick,
  color,
}: IDropdownHeaderProps): JSX.Element => (
  <DropdownHeaderStyled
    isOpened={isOpened}
    width={width}
    height={height}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    paddings={paddings}
    onClick={onClick}
    colorDefault={color}
  >
    {children}
  </DropdownHeaderStyled>
)
